"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _clsx11 = _interopRequireDefault(require("clsx"));

var _reactRouter = require("react-router");

var _get2 = _interopRequireDefault(require("lodash/get"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _commonRichText = require("@mmc/common-rich-text");

var _text = require("@mmc/text");

var _textBlock = _interopRequireDefault(require("../styles/text-block.css"));

var _textBlock2 = require("./text-block.props/text-block.propTypes");

var _DataUtils = new _mmcDataUtilities["default"](),
    renderEmptyString = _DataUtils.renderEmptyString,
    handleNestedProp = _DataUtils.handleNestedProp;

var TextBlock = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(TextBlock, _React$Component);

  function TextBlock() {
    return _React$Component.apply(this, arguments) || this;
  }

  // All components need a resourceType in order for AEM to be aware of its existence
  TextBlock.resourceType = function resourceType() {
    return 'TextBlock_1_0_0';
  };

  TextBlock.configureColWidth = function configureColWidth(_textAlignment, _theme, fullWidth) {
    var colWidthsArray = [_theme['col-sm-1'], _theme['col-sm-8'], _theme['col-sm-3']];

    switch (_textAlignment) {
      case 'left':
        colWidthsArray = [_theme['col-sm-1'], _theme['col-sm-8'], _theme['col-sm-3']];
        break;

      case 'center':
        colWidthsArray = fullWidth ? [_theme['col-sm-12']] : [_theme['col-sm-2'], _theme['col-sm-8'], _theme['col-sm-2']];
        break;

      case 'right':
        colWidthsArray = [_theme['col-sm-3'], _theme['col-sm-8'], _theme['col-sm-1']];
        break;

      default:
        colWidthsArray = [_theme['col-sm-1'], _theme['col-sm-8'], _theme['col-sm-3']];
    }

    return colWidthsArray;
  };

  TextBlock.getHeadTag = function getHeadTag(width, theme, mainHeading, headingTag, disclaimerData, isSectionHeadingPresent) {
    var _clsx, _clsx2, _clsx3, _clsx4;

    var headingTagMap = {
      h1: 'headingOne',
      h2: 'headingTwo',
      h3: 'headingThree',
      h4: 'headingFour',
      h5: 'headingFive',
      h6: 'headingSix'
    };
    var headingTagMapClass = (headingTagMap == null ? void 0 : headingTagMap[headingTag]) || 'headingOne';

    switch (width) {
      case 'span100':
        return /*#__PURE__*/_react["default"].createElement(_text.Text, {
          tag: headingTag || 'h1',
          text: mainHeading,
          className: (0, _clsx11["default"])(theme[headingTagMapClass], _textBlock["default"].headline, (_clsx = {}, _clsx[_textBlock["default"].marginIntermediate] = isSectionHeadingPresent, _clsx)),
          disclaimerData: disclaimerData
        });

      case 'span75':
        return /*#__PURE__*/_react["default"].createElement(_text.Text, {
          tag: headingTag || 'h2',
          text: mainHeading,
          className: (0, _clsx11["default"])(theme[headingTagMapClass], _textBlock["default"].headline, (_clsx2 = {}, _clsx2[_textBlock["default"].marginIntermediate] = isSectionHeadingPresent, _clsx2)),
          disclaimerData: disclaimerData
        });

      case 'span50':
        return /*#__PURE__*/_react["default"].createElement(_text.Text, {
          tag: headingTag || 'h3',
          text: mainHeading,
          className: (0, _clsx11["default"])(theme[headingTagMapClass], _textBlock["default"].headline, (_clsx3 = {}, _clsx3[_textBlock["default"].marginIntermediate] = isSectionHeadingPresent, _clsx3)),
          disclaimerData: disclaimerData
        });

      default:
        return /*#__PURE__*/_react["default"].createElement(_text.Text, {
          tag: headingTag || 'h1',
          text: mainHeading,
          className: (0, _clsx11["default"])(theme[headingTagMapClass], _textBlock["default"].headline, (_clsx4 = {}, _clsx4[_textBlock["default"].marginIntermediate] = isSectionHeadingPresent, _clsx4)),
          disclaimerData: disclaimerData
        });
    }
  };

  TextBlock.checkForData = function checkForData(data) {
    return data !== ' ' && data !== '' && data !== null;
  };

  TextBlock.applyDarkTheme = function applyDarkTheme(itemTheme, theme) {
    return itemTheme === 'dark' ? theme[itemTheme] : '';
  };

  var _proto = TextBlock.prototype;

  _proto.render = function render() {
    var _clsx5, _clsx6, _clsx7, _clsx8, _clsx9, _clsx10;

    var _this$props = this.props,
        data = _this$props.data,
        theme = _this$props.theme,
        router = _this$props.router,
        fullWidth = _this$props.fullWidth;
    var dontRenderOn = ['payment-calc'];

    var _get = (0, _get2["default"])(router, 'location.query'),
        component = _get.component;

    if (dontRenderOn.includes(component)) {
      return null;
    } // destructure items off data that the component needs


    var sectionHeading = data.sectionHeading,
        paragraph = data.paragraph,
        mainHeading = data.mainHeading,
        headingTag = data.headingTag,
        textAlignment = data.textAlignment,
        width = data.width,
        componentTheme = data.theme,
        disclaimerData = data.disclaimerData;
    var isTextRightAligned = textAlignment === 'right';
    var isTextLeftAligned = textAlignment === 'left';
    var isDarkComponent = componentTheme === 'dark';
    var isSectionHeadingPresent = TextBlock.checkForData(handleNestedProp(data, 'data.sectionHeading'));
    var isMainHeadingPresent = TextBlock.checkForData(handleNestedProp(data, 'data.mainHeading'));
    var isParagraphPresent = TextBlock.checkForData(handleNestedProp(data, 'data.paragraph'));
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx11["default"])(theme['container-fluid'], _textBlock["default"].wrapper, TextBlock.applyDarkTheme(componentTheme, theme))
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx11["default"])(theme['col-xs-12'], TextBlock.configureColWidth(textAlignment, theme, fullWidth)[0], (_clsx5 = {}, _clsx5[_textBlock["default"].formChild] = isTextLeftAligned, _clsx5))
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx11["default"])(theme['col-xs-12'], TextBlock.configureColWidth(textAlignment, theme, fullWidth)[1], _textBlock["default"]["defaultAlign" + textAlignment], (_clsx6 = {}, _clsx6[_textBlock["default"].formNoLeftPad] = isTextLeftAligned, _clsx6[_textBlock["default"].formNoRightPad] = isTextRightAligned, _clsx6[_textBlock["default"].rightWidthFix] = isTextRightAligned, _clsx6))
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx11["default"])(_textBlock["default"].contentWrapper, (_clsx7 = {}, _clsx7[_textBlock["default"][width]] = renderEmptyString(width) !== ' ', _clsx7))
    }, isSectionHeadingPresent && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: sectionHeading,
      className: (0, _clsx11["default"])(theme.labelMedium, _textBlock["default"].subHeadline, (_clsx8 = {}, _clsx8[_textBlock["default"].greyButton] = !isDarkComponent, _clsx8)),
      disclaimerData: disclaimerData
    }), isMainHeadingPresent && TextBlock.getHeadTag(width, theme, mainHeading, headingTag, disclaimerData, isSectionHeadingPresent), isParagraphPresent && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx11["default"])(theme.bodyCopy, _textBlock["default"].paragraph)
    }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        html: paragraph,
        theme: componentTheme,
        className: (0, _clsx11["default"])((_clsx9 = {}, _clsx9[_textBlock["default"].greyButton] = !isDarkComponent, _clsx9[_textBlock["default"].marginIntermediate] = isSectionHeadingPresent || isMainHeadingPresent, _clsx9))
      }),
      disclaimerData: disclaimerData
    })))), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx11["default"])(theme['col-xs-12'], TextBlock.configureColWidth(textAlignment, theme, fullWidth)[2], (_clsx10 = {}, _clsx10[_textBlock["default"].formChild] = isTextRightAligned, _clsx10))
    })));
  };

  return TextBlock;
}(_react["default"].Component);

TextBlock.displayName = 'TextBlock';

var _default = (0, _reactRouter.withRouter)(TextBlock);

exports["default"] = _default;